import { Route, Routes } from 'react-router-dom'

import { ROUTES } from '../../../routes/RouteEnums'
import { RegistrationPage } from '../RegistrationPage'
import { Redirect } from '../Redirect'
import { getIdentityAppUrl } from '../../../utils/helpers/url.helpers'

export const NonAuthenticated = () => {
  const loginUrl = getIdentityAppUrl('login')
  const recoveryUrl = getIdentityAppUrl('recovery')

  return (
    <Routes>
      <Route
        path={ROUTES.RESET_PASSWORD}
        element={<Redirect url={recoveryUrl} />}
      />
      <Route path={ROUTES.REGISTER} element={<RegistrationPage />} />
      <Route
        path="*"
        element={<Redirect url={loginUrl} />}
      />
    </Routes>
  )
}
